import React, { useEffect, Fragment } from "react";
import "./envTemp.css";
import { Grid } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import { GenericEnvTempAccordion } from "./env-temp-generic";
interface IProps {
  data: { [tab: string]: EnvTempSections };
  styles: { [tab: string]: EnvTempStyles };
  refreshData: () => void;
}
const styles = {
  tab_icon: {
    height: 120,
    width: 120,
    borderRadius: 0,
  },
};
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 500,
    alignItems: "flex-start",
  },
});
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    width: 400,
    backgroundColor: "white",
    border: "2px solid #000",
    boxShadow: "10px 5px 5px grey",
    padding: 3,
  };
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: any) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    "aria-controls": `scrollable-prevent-tabpanel-${index}`,
  };
}

export const EnvTempContent: React.FC<IProps> = (props: IProps) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [guideHtml, setGuideHtml] = React.useState<string>("");
  const handleOpen = (guideHtml: string) => {
    setOpen(true);
    setGuideHtml(guideHtml);
  };
  const [modalStyle] = React.useState(getModalStyle);

  const handleClose = () => {
    setOpen(false);
  };
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [sectionCompletion, setSectionCompletion] = React.useState<{
    [section: string]: number;
  }>({});
  const [render, reRender] = React.useState<boolean>(false);
  useEffect(() => {
    if (Object.keys(sectionCompletion).length === 0) {
      const sectionCompletionTemp: { [section: string]: number } = {};
      Object.keys(props.data).map((section) => {
        let totalCompleted = 0;
        Object.keys(props.data[section].subThemes).forEach((subTheme) =>
          props.data[section].subThemes[subTheme].themeItems.forEach(
            (themeItem: ThemeItem) => {
              if (themeItem.completed) {
                totalCompleted = totalCompleted + 1;
              }
            }
          )
        );
        sectionCompletionTemp[section] = totalCompleted;
      });
      setSectionCompletion(sectionCompletionTemp);
    }
  }, []);
  const addRemoveCompletion = (section: string, amount: number) => {
    sectionCompletion[section] = (sectionCompletion[section] | 0) + amount;
    setSectionCompletion(sectionCompletion);
    reRender(!render);
  };
  const handleChange = (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => {
    setValue(newValue);
  };
  const [selectedTab, setSelectedTab] = React.useState<string>(
    Object.keys(props.data)[0]
  );
  const [questionCounts, setQuestionCounts] = React.useState<{
    [section: string]: number;
  }>({});
  return (
    <div className="content_container">
      Click on an icon to begin completing the associated template or review
      previous input data.
      {/* <AppBar position="static"> */}
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 5,
          width: "100%",
          marginLeft: 0,
        }}
      >
        {Object.keys(props.data).map((tabName: string) => {
          let totalThemeItems = 0;
          Object.keys(props.data[tabName].subThemes).forEach((section) => {
            props.data[tabName].subThemes[section].themeItems.forEach(
              (themeItem: ThemeItem) => {
                totalThemeItems = totalThemeItems + 1;
              }
            );
            const existingQuestionCounts = questionCounts;
            existingQuestionCounts[tabName] = totalThemeItems;
            // setQuestionCounts(existingQuestionCounts);
          });
          return (
            <Fragment key={tabName}>
              <Grid
                item
                xs={2}
                style={{
                  background: props.styles[tabName].themeBackground,
                  textAlign: "center",
                  color: "white",
                  // borderColor: selectedTab === tabName ? 'red' : 'white',
                  // borderBottomStyle: 'solid',
                  opacity: selectedTab === tabName ? 1 : 0.5,
                }}
                key={tabName}
                onClick={() => {
                  setSelectedTab(tabName);
                }}
              >
                <img
                  src={props.styles[tabName].img}
                  style={{ width: "100px" }}
                />
                <div style={{ fontSize: 14 }}>{tabName}</div>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 5,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
        {Object.keys(props.data).map((tabName: string) => {
          return (
            <Fragment key={tabName}>
              <Grid
                item
                xs={2}
                style={{
                  background: props.styles[tabName].themeBackground,

                  textAlign: "center",
                  color: "white",
                  borderColor: selectedTab === tabName ? "red" : "white",
                  borderBottomStyle: "solid",
                  opacity: selectedTab === tabName ? 1 : 0.5,
                }}
                key={tabName}
                onClick={() => {
                  setSelectedTab(tabName);
                }}
              >
                <div style={{ cursor: "pointer" }}>
                  {(
                    ((sectionCompletion[tabName] | 0) /
                      questionCounts[tabName]) *
                    100
                  ).toFixed(0) + "%"}
                </div>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
      The {selectedTab} theme comprises of{" "}
      {Object.keys(props.data[selectedTab].subThemes).length} sub-themes;{" "}
      {Object.keys(props.data[selectedTab].subThemes).map(
        (subTheme: string, index) => {
          let postText = ", ";
          if (
            index ===
            Object.keys(props.data[selectedTab].subThemes).length - 2
          ) {
            postText = " and ";
          } else if (
            index ===
            Object.keys(props.data[selectedTab].subThemes).length - 1
          ) {
            postText = ".";
          }
          return subTheme + postText;
        }
      )}
      <br />
      <br />
      Questions answered: {sectionCompletion[selectedTab] | 0} /{" "}
      {questionCounts[selectedTab] | 0}
      <br />
      <br />
      {/* </AppBar> */}
      <GenericEnvTempAccordion
        data={props.data[selectedTab]}
        envStyles={props.styles[selectedTab]}
        addRemoveCompletion={addRemoveCompletion}
        tabName={selectedTab}
        refreshData={props.refreshData}
        handleOpen={handleOpen}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div
          style={{
            top: "50%",
            left: "50%",
            padding: "50px 30px 10px 30px",
            width: "80%",
            maxWidth: "800px",
            //height:"50%",
            transform: `translate(-50%, -50%)`,
            backgroundColor: "white",
            position: "absolute",
            maxHeight: "90%",
            overflow: "auto",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: guideHtml }}></div>
        </div>
      </Modal>
    </div>
  );
};
